<p-dialog
  [(visible)]="visible"
  [dismissableMask]="false"
  modal="true"
  [styleClass]="'md:col-6 height-half'"
  [closable]="error"
  (onHide)="close()"
  appendTo="body"
  >
  <!-- <div class="logo"></div> -->
  <div class="flex flex-column align-items-center">
    @if (error === false) {
      <div class="grid">
        <div class="col-12">
        </div>
        <div class="col-12 logo">
          {{ message }}<span>.</span><span>.</span><span>.</span>
        </div>
      </div>
    }
    @if (error === true) {
      <div class="error">
        {{ errorMessage }}
      </div>
    }
    @if (displayPbar === true) {
      <div class="pbar">
        <p-progressBar
          [showValue]="false"
          [value]="pBarValue"
          [style]="{ height: '15px', width: '100%', 'margin-top': '15px' }"
        ></p-progressBar>
        <div class="p-bar">{{ pBarValue }} %</div>
      </div>
    }
    @if (displayPbar === false) {
      <div id="floatingCirclesG">
        <p-progressSpinner></p-progressSpinner>
      </div>
    }
  </div>
</p-dialog>
